import styled from '@emotion/styled';
import { m } from 'framer-motion';

import { screen } from '@/components/common/breakpoints';

const NoResults = () => {
  return (
    <NoResDiv
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }}
      aria-live="assertive"
      aria-atomic
    >
      <NoResHeading aria-live="polite" aria-atomic>
        Sorry, no results found!
      </NoResHeading>
      <NoResSubHeading>
        We couldn’t find what you are looking for. Please try another way.
      </NoResSubHeading>
      <ImageContainer>
        <NoResultsImg src="/images/no-results.svg" alt="" />
      </ImageContainer>
    </NoResDiv>
  );
};

const NoResDiv = styled(m.div)`
  ${screen.sm} {
    width: 626px;
  }

  ${screen.md} {
    width: 836px;
  }
`;

const NoResHeading = styled.p`
  font-size: var(--font-size-small);
  margin-top: var(--spacing-xxx-large);
  margin-bottom: var(--spacing-x-small);
`;

const NoResSubHeading = styled.p`
  letter-spacing: var(--letter-spacing-medium);
  margin-bottom: var(--spacing-xx-large);
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const NoResultsImg = styled.img`
  max-width: 200px;
  width: 100%;
  height: auto;
  margin-bottom: var(--spacing-xxx-large);
`;

export { NoResults };
